/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconTorii = createReactComponent("torii", "IconTorii", [
  ["path", { d: "M4 4c5.333 1.333 10.667 1.333 16 0", key: "svg-0" }],
  ["path", { d: "M4 8h16", key: "svg-1" }],
  ["path", { d: "M12 5v3", key: "svg-2" }],
  ["path", { d: "M18 4.5v15.5", key: "svg-3" }],
  ["path", { d: "M6 4.5v15.5", key: "svg-4" }]
]);

export { IconTorii as default };
//# sourceMappingURL=IconTorii.js.map
